import type { ApiProjectImage } from '../../lib/projects.js';

// Each project image is credited to the filing or page it came from.

const monthYear = (isoDate: string) =>
  new Date(`${isoDate}T00:00:00Z`).toLocaleString('en-US', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });

export function imageCreditLine(image: ApiProjectImage): string {
  const { publisher_name, document_type, document_date } = image.attribution;
  return [
    `Image: ${publisher_name}`,
    document_type,
    document_date ? monthYear(document_date) : null,
  ]
    .filter(Boolean)
    .join(' · ');
}

/** The source page, or the filing opened at the image's page. */
export function imageSourceHref(image: ApiProjectImage): string {
  const { source_page_url, page_number } = image.attribution;
  return page_number && !source_page_url.includes('#')
    ? `${source_page_url}#page=${page_number}`
    : source_page_url;
}

const KIND_LABELS: Record<ApiProjectImage['kind'], string> = {
  rendering: 'Rendering',
  site_plan: 'Site plan',
  photo: 'Photo',
  unknown: 'Image',
};

export function imageKindLabel(kind: ApiProjectImage['kind']): string {
  return KIND_LABELS[kind];
}
